@if (marker && (currentUser$ | async); as user) {
  <div class="container">
    <!------- Header ------->
    <div
      class="header"
      [ngClass]="(isExpanded$ | async) ? 'header-expanded' : 'header-collapsed'">
      <div class="header-left">
        <div class="info">
          <div class="title">{{ marker.name }}</div>
          <div class="sub-title">{{ marker.center | wgs84 }}</div>
        </div>
      </div>
      <div class="header-actions">
        @if (!(isExpanded$ | async)) {
          <button
            mat-icon-button
            matTooltip="{{ 'expand' | transloco }}"
            (click)="onClickExpand()">
            expand_content
          </button>
        }
        @if ((isExpanded$ | async)) {
          <button
            mat-icon-button
            matTooltip="{{ 'collapse' | transloco }}"
            (click)="onClickCollapse()">
            collapse_content
          </button>
        }
        <button
          mat-icon-button
          matTooltip="{{ 'close' | transloco }}"
          (click)="onClickClose()">
          close
        </button>
      </div>
    </div>
    <!------- Content ------->
    <div
      class="content"
      [ngClass]="(isExpanded$ | async) ? 'content-expanded' : 'content-collapsed'">
      <div
        class="main"
        [ngClass]="(isExpanded$ | async) ? 'main-expanded' : 'main-collapsed'">
        <!------- Split buttons ------->
        @if ((isExpanded$ | async) && referenceBatch) {
          <div class="buttons">
            <mat-button-toggle-group
              [hideSingleSelectionIndicator]="true"
              [value]="selectedSplitScreenMode"
              (change)="onSplitModeChanged($event.value)">
              <mat-button-toggle [checked]="selectedSplitScreenMode == 0" value="0">
                <mat-icon>splitscreen_left</mat-icon>
              </mat-button-toggle>
              <mat-button-toggle [checked]="selectedSplitScreenMode == 1" value="1">
                <mat-icon>split_scene</mat-icon>
              </mat-button-toggle>
              <mat-button-toggle [checked]="selectedSplitScreenMode == 2" value="2">
                <mat-icon>splitscreen_right</mat-icon>
              </mat-button-toggle>
            </mat-button-toggle-group>
          </div>
        }
        <!------- Pictures ------->
        @if ((isExpanded$ | async)) {
          <div class="pictures">
            <!------- Reference batch ------->
            @if (referenceBatch) {
              <div
                class="left"
          [ngClass]="{
            'left-expanded': (isExpanded$ | async),
            'left-side-open': (isExpanded$ | async) && selectedSplitScreenMode == 0,
            'left-side-close': (isExpanded$ | async) && selectedSplitScreenMode == 2
          }">
                @if (selectedSplitScreenMode != 2) {
                  <mat-label>
                    {{ referenceBatch.dateAcquired | date:dateFormat(user) }}
                  </mat-label>
                }
                @if (referenceAttachments.length) {
                  <div
                    class="attachments-carousel-host">
                    @if ((currentOrganizationId$ | async); as organizationId) {
                      <attachments-carousel
                        [attachments]="referenceAttachments"
                        [organizationId]="organizationId"
                        [enablePanzoom]="true"
                        [showOverlay]="true"
                        [allowDownload]="true"
                        [navigationMode]="'thumbnails'">
                      </attachments-carousel>
                    }
                  </div>
                }
                @if (!referenceAttachments.length) {
                  <div
                    class="empty-picture">
                    <mat-icon>broken_image</mat-icon>
                  </div>
                }
              </div>
            }
            <!------- Last batch ------->
            <div
              class="right"
          [ngClass]="{
            'right-expanded': (isExpanded$ | async),
            'right-side-open': (isExpanded$ | async) && selectedSplitScreenMode == 2,
            'right-side-close': (isExpanded$ | async) && selectedSplitScreenMode == 0,
            'full-size': (isExpanded$ | async) && !referenceBatch
          }">
              @if (selectedSplitScreenMode != 0 && site && referenceBatch) {
                <mat-label>
                  {{ site.lastBatchDate | date:dateFormat(user) }}
                </mat-label>
              }
              @if (lastAttachments.length) {
                <div
                  class="attachments-carousel-host">
                  @if ((currentOrganizationId$ | async); as organizationId) {
                    <attachments-carousel
                      [attachments]="lastAttachments"
                      [organizationId]="organizationId"
                      [enablePanzoom]="true"
                      [showOverlay]="true"
                      [allowDownload]="true"
                      [navigationMode]="'thumbnails'">
                    </attachments-carousel>
                  }
                </div>
              }
              @if (!lastAttachments.length) {
                <div
                  class="empty-picture">
                  <mat-icon>broken_image</mat-icon>
                </div>
              }
            </div>
          </div>
        }
        <!------- Actions ------->
        <div class="actions">
          @if (!(isExpanded$ | async)) {
            <button
              mat-icon-button
              matTooltip="{{ 'move_the_camera_on_the_maker' | transloco }}"
              class="material-symbols-outlined"
              (click)="onClickFlyTo(marker)">
              my_location
            </button>
          }
          @if (!(isExpanded$ | async)) {
            <button
              mat-icon-button
              [matTooltip]="(marker.show ? 'hide_overlay' : 'show_overlay') | transloco"
              [disabled]="!(displayMarkers$ | async)"
              (click)="onClickToggleShow(marker)">
              <mat-icon>
                {{ marker.show ? 'visibility' : 'visibility_off' }}
              </mat-icon>
            </button>
          }
          @if (user.name == marker.author) {
            <button
              mat-icon-button
              matTooltip="{{ 'rename' | transloco }}"
              (click)="onClickRename(marker)">
              <mat-icon>edit</mat-icon>
            </button>
          }
          @if (!marker.isShared && user.name == marker.author) {
            <button
              mat-icon-button
              matTooltip="{{ 'share' | transloco }}"
              (click)="onClickToggleShare(marker)">
              <mat-icon>share</mat-icon>
            </button>
          }
          @if (marker.isShared && user.name == marker.author) {
            <button
              mat-icon-button
              matTooltip="{{ 'share_off' | transloco }}"
              (click)="onClickToggleShare(marker)">
              <mat-icon>share_off</mat-icon>
            </button>
          }
          <span class="spacer"></span>
          @if (user.name == marker.author) {
            <button
              style="color: var(--warn-color)"
              mat-icon-button
              matTooltip="{{ 'delete' | transloco }}"
              (click)="onClickDelete(marker)">
              delete
            </button>
          }
        </div>
      </div>
      <div
        class="side"
        [ngClass]="(isExpanded$ | async) ? 'side-expanded' : 'side-collapsed'">
        <tracker-history-channel
          class="history"
          [itemId]="marker.id">
      </tracker-history-channel>
    </div>
  </div>
</div>
}
